
/**
 * Based on
 * https://github.com/ngrx/example-app/blob/master/src/app/util.ts
 *
 * This function coerces a string into a string literal type.
 * Using tagged union types in TypeScript 2.0, this enables
 * powerful typechecking of our reducers.
 *
 * Since every action label passes through this function it
 * is a good place to ensure all of our action labels
 * are unique.
 */

const typeCache: { [label: string]: boolean } = {};

export function types(): string[] {
  return Object.keys(typeCache);
}

export function type<T>(label: T | ''): T {
  if (typeCache[label as string]) {
    throw new Error(`Action type "${label as string}" is not unique"`);
  }

  typeCache[label as string] = true;

  return label as T;
}
